import { useTranslation } from 'next-i18next';
import { DialogHeader } from '@/ui_v3';
export const Header = ({
  onClose
}: {
  onClose: () => void;
}) => {
  const {
    t
  } = useTranslation(['build']);
  return <DialogHeader title={t('build:similarQuiz.modal.title')} hasCloseButton onClose={onClose} className="h-[68px]" data-sentry-element="DialogHeader" data-sentry-component="Header" data-sentry-source-file="Header.tsx" />;
};